"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiChip = void 0;
var palette_1 = require("../../global/palette");
var typography_1 = require("../../../theme/global/typography");
exports.MuiChip = {
    root: __assign(__assign({}, typography_1.typography.caption), { color: palette_1.palette.common['black'], backgroundColor: palette_1.palette.grey[200], padding: 8 }),
    outlined: {
        backgroundColor: palette_1.palette.common['white'],
        borderColor: palette_1.palette.grey[300],
        padding: 8,
        '&.MuiChip-clickable': {
            '&:hover': {
                borderColor: palette_1.palette.grey[400],
                backgroundColor: palette_1.palette.common['white'],
            },
            '&:active': {
                borderColor: palette_1.palette.grey[600],
                backgroundColor: palette_1.palette.common['white'],
                boxShadow: 'none',
            },
        },
    },
    deleteIcon: {
        color: palette_1.palette.grey[500],
        height: 16,
        marginRight: -4,
        marginBottom: 1,
        '&:hover': {
            color: palette_1.palette.grey[600],
            height: 16,
        },
        '&:active': {
            color: palette_1.palette.grey[800],
            height: 16,
        },
    },
    icon: {
        height: 16,
        color: palette_1.palette.common['black'],
        marginLeft: 0,
    },
    label: {
        paddingLeft: 8,
        paddingRight: 8,
    },
    clickable: {
        '&:active:not(.MuiChip-outlined)': {
            boxShadow: 'none',
            backgroundColor: palette_1.palette.grey[400],
        },
        '&:hover:not(&:active):not(.MuiChip-outlined)': {
            backgroundColor: palette_1.palette.grey[300],
        },
    },
    deletable: {
        '&:hover': {
            backgroundColor: palette_1.palette.grey[300],
        },
        '&:active': {
            backgroundColor: palette_1.palette.grey[400],
        },
    },
};
